import { useContext, useState } from 'react'
import Layout from 'shared/layouts/Main'
import useInit from './hooks/useInit'
import getRows from './utils/getRows'
import DeleteModal from 'shared/components/DeleteModal'
import { apiUrls, tableColumnWidths, roles } from 'consts'
import {
  PagingState,
  SearchState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  SortingState,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  SearchPanel,
  Table,
  TableColumnResizing,
  TableHeaderRow,
  Toolbar,
  PagingPanel,
} from '@devexpress/dx-react-grid-bootstrap4'
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid/dist/dx-react-grid'
import HeaderCustomerSelect from 'containers/HeaderCustomerSelect'
import hasAnyRole from 'shared/utils/hasAnyRole'
import getBrandContent from 'utils/getBrandContent'
import SearchPanelInput from 'shared/components/SearchPanelInput'
import Footer from 'shared/components/Footer'
import getPageSize from 'utils/getPageSize'
import { ReactReduxContext } from 'react-redux'
import LayoutSwitcher from 'components/LayoutSwitcher'
import { NavLink } from 'react-router-dom'
import { cloudUpload } from 'ionicons/icons'
import { IonIcon } from '@ionic/react'

const Filters: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [rows, setRows] = useState<any>([])
  const [showModal, setShowModal] = useState<boolean>(false)
  const [filter, setFilter] = useState<object | null>(null)
  const [deleteEntryId, setDeleteEntryId] = useState<boolean | number>(false)
  const [currentCustomer, setCurrentCustomer] = useState<{} | null>({})
  const [filterVisible, setFilterVisible] = useState<boolean>(false)

  const { store } = useContext(ReactReduxContext)

  const columns: { name: string; title: string; encodeHtml?: boolean; getCellValue?: any }[] = [
    { name: 'name', title: 'Name' },
    { name: 'parent_filter_name', title: 'Parent Filter' },
    { name: 'is_multi', title: 'Multi Value' },
    { name: 'sync', title: 'Synchronize' },
    { name: 'last_sync_date', title: 'Last Sync Date' },
    { name: 'active', title: 'Active' },
    { name: 'action', title: 'Action', encodeHtml: false },
  ]

  const columnWidths: TableColumnWidthInfo[] = [
    { columnName: 'name', width: 'auto' },
    { columnName: 'parent_filter_name', width: 'auto' },
    { columnName: 'is_multi', width: 'auto' },
    { columnName: 'sync', width: 'auto' },
    { columnName: 'last_sync_date', width: 'auto' },
    { columnName: 'active', width: tableColumnWidths.active },
    { columnName: 'action', width: tableColumnWidths.extended_action },
  ]

  useInit({
    setRows,
    setDeleteEntryId,
    setShowModal,
    setShowOverlay,
    filter,
    currentCustomer
  })



  const TableComponent = ({ ...restProps }) => (
    <Table.Table {...restProps} className='small with-action min-mobile-width' />
  )
  const isAdmin: boolean = hasAnyRole([roles.admin, roles.superAdmin])

  const SearchPanelInputComponent = (props) => {
    return SearchPanelInput({
      addUrl: isAdmin ? '/add-filter' : undefined,
      addText: isAdmin ? 'Add Filter' : undefined,
      inputProps: props,
      insert: (
        <>
          <NavLink to={'/import-filter-values'} className='btn btn-primary me-3'>
            <IonIcon
              icon={cloudUpload}
              className='ionicon'
              style={{ fontSize: '16px', marginBottom: '-3px' }}
              />
            Import Filter Values
          </NavLink>
        </>
      ),
    })
  }

  const PagingContainer = (props) => {
    return <PagingPanel.Container {...props} className='table-footer' />
  }

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      headerInsert={
        <>
          {hasAnyRole([roles.superAdmin]) && (
            <HeaderCustomerSelect
              setShowOverlay={setShowOverlay}
              handleCustomerChanged={(customer) => setCurrentCustomer(customer)}
            />
          )}
        </>
      }
      menuBottomInsert={hasAnyRole([roles.superAdmin]) ? <LayoutSwitcher store={store} /> : false}
    >
      <>
        <Grid rows={rows} columns={columns}>
          <SortingState defaultSorting={[{ columnName: 'name', direction: 'asc' }]} />
          <SearchState defaultValue='' />
          <IntegratedFiltering />
          <PagingState defaultCurrentPage={0} pageSize={getPageSize()} />
          <IntegratedSorting />
          <IntegratedPaging />
          <Toolbar />
          <SearchPanel inputComponent={SearchPanelInputComponent} />
          <Table tableComponent={TableComponent} />
          <TableColumnResizing defaultColumnWidths={columnWidths} resizingMode='nextColumn' />
          <TableHeaderRow showSortingControls />
          <PagingPanel pageSizes={[]} containerComponent={PagingContainer} />
        </Grid>

        <DeleteModal
          url={apiUrls.filters}
          showModal={showModal}
          setShowModal={setShowModal}
          deleteEntryId={deleteEntryId}
          setDeleteEntryId={setDeleteEntryId}
          entityName='Filter'
          getRows={getRows}
          setRows={setRows}
          customConfirmMessage={{
            rows,
            confirmMessage: (row) => {
              let confirmMessage = 'Are you sure you want to delete this Filter'

              if (row.includes_filter_values) {
                confirmMessage += ' with all included Filter Values'
              }
              confirmMessage += '? '

              const includedEntites: Array<string> = []

              if (row.is_included_in_pages) {
                includedEntites.push('Page(s)')
              }

              if (row.is_included_in_reports) {
                includedEntites.push('Report(s)')
              }

              if (includedEntites.length > 0) {
                confirmMessage +=
                  'Note that this Filter is also included in ' + includedEntites.join(' and ') + '.'
              }

              return confirmMessage
            },
          }}
        />
      </>
    </Layout>
  )
}

export default Filters
